import type { InventoryStatus } from '@/modules/inventory/types';
import { INVENTORY_STATUS_LABELS } from '@/modules/inventory/types';

const STATUS_CLASS: Record<InventoryStatus, string> = {
  available: 'status-badge--available',
  reserved: 'status-badge--reserved',
  in_use: 'status-badge--in-use',
  maintenance: 'status-badge--maintenance',
  repair: 'status-badge--repair',
  inspection: 'status-badge--maintenance',
  sold: 'status-badge--sold',
  inactive: 'status-badge--inactive',
};

type InventoryStatusBadgeProps = {
  status: InventoryStatus;
};

export function InventoryStatusBadge({ status }: InventoryStatusBadgeProps) {
  return (
    <span className={`status-badge ${STATUS_CLASS[status]}`}>
      {INVENTORY_STATUS_LABELS[status]}
    </span>
  );
}
